import { Injectable } from '@angular/core';
import { initializeApp, getApps, FirebaseApp, FirebaseOptions } from 'firebase/app';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirebaseInitService {
  private firebaseApp: FirebaseApp | null = null;

  init(): void {
    if (getApps().length > 0) {
      this.firebaseApp = getApps()[0];
      return;
    }

    const firebaseConfig: FirebaseOptions = {
      apiKey: environment.firebaseConfig.apiKey,
      authDomain: environment.firebaseConfig.authDomain,
    };

    this.firebaseApp = initializeApp(firebaseConfig);
  }

  getFirebaseApp(): FirebaseApp | null {
    if (getApps().length > 0) {
      return getApps()[0];
    }
    return this.firebaseApp;
  }

  isFirebaseInitialized(): boolean {
    return getApps().length > 0;
  }
}

